import { useMediaQuery } from 'utils/hooks/use_media_query';

const useBootStrapMediaQuery = () => {
  const SM_BREAKPOINT = 576;
  const MD_BREAKPOINT = 768;
  const LG_BREAKPOINT = 992;
  const XL_BREAKPOINT = 1200;
  const XXl_BREAKPOINT = 1400;

  const downSm = useMediaQuery(`(max-width: ${SM_BREAKPOINT}px)`);
  const downMd = useMediaQuery(`(max-width: ${MD_BREAKPOINT}px)`);
  const downLg = useMediaQuery(`(max-width: ${LG_BREAKPOINT}px)`);
  const downXl = useMediaQuery(`(max-width: ${XL_BREAKPOINT}px)`);
  const downXxl = useMediaQuery(`(max-width: ${XXl_BREAKPOINT}px)`);

  const upSm = !downSm;
  const upMd = !downMd;
  const upLg = !downLg;
  const upXl = !downXl;
  const upXxl = !downXxl;

  return {
    upSm,
    upMd,
    upLg,
    upXl,
    upXxl,
    downSm,
    downMd,
    downLg,
    downXl,
    downXxl,
  };
};

export default useBootStrapMediaQuery;
